import React, { useEffect, useState } from 'react'
import { View, StyleSheet, Image, Dimensions, ScrollView } from 'react-native'
import Colors from '../../constants/Colors'
import { txt } from '../../locales/i18n'
import { CustomText } from '../../components/text/StyledText'
import PageTitle from '../../components/tags/PageTitle'
import TxtTMD from '../../constants/TxtTMD'
import Layout from '../../constants/Layout'
import MainContainer from '../../components/MainContainer/MainContainer'
import store from '../../redux/store'
import { CornerStyles } from '../../styles'
import { URLOpener } from '../../utils/URLOpener'
import { useNavigation } from '@react-navigation/core'
import { dropShadow } from '../../styles/shadows'
import { getVolunteerAccess } from '../../services/api/volunteerApi'
import InformationDialog from './InformationDialog'
import CustomPressable from "../../components/pressables/CustomPressable"

const { width } = Dimensions.get('window')

export default function SnakSammenIntroScreen() {
  const [userToken, setUserToken] = useState(null)
  const [visible, setVisible] = useState(false)
  const [isVolunteer, setIsVolunteer] = useState(false)
  const navigation = useNavigation()

  useEffect(() => {
    const userToken = store.getState().userToken
    getVolunteerAccess('snaksammen').then((access) => setIsVolunteer(access?.isVolunteer || false))

    setUserToken(userToken)
    navigation.setOptions({
      headerBackTitle: ' ',
      headerStyle: { 
        backgroundColor: Colors.background,
        borderBottomColor: 'transparent',
        elevation: 0, // remove shadow on Android
        shadowOpacity: 0,
        height: 100
      },
      headerTitle: () => (
        <Image
          style={styles.logo}
          resizeMode="contain"
          source={{ uri: 'https://filer.boblberg.dk/assets/img/snaksammen/snaksammen-logo.png' }}
          accessibilityLabel={'Snaksammen logo'}
          accessibilityIgnoresInvertColors
        />
      ),
    })
  }, [])

  const handleGetStartedClick = () => {
    if (userToken) navigation.navigate('SnakSammenOversigt')
    else navigation.navigate('SnakSammenSignup')
  }

  const closeRequest = () => setVisible(false)

  return (
    <MainContainer noScroll>
      <PageTitle title={TxtTMD.snakSammen.title[TxtTMD.lang]} />
      <ScrollView style={styles.container}>
        <Image
          style={styles.bannerImage}
          resizeMode={'contain'}
          accessibilityIgnoresInvertColors
          source={{
            uri: 'https://filer.boblberg.dk/Assets/Img/snaksammen/snaksammen-banner.png',
          }}
        />

        <View style={styles.contentContainer}>
          <CustomText accessibilityRole="header" font="largeBold" aria-level={1} style={styles.title}>
            {txt('videoChat.intro.title')}
          </CustomText>

          <CustomText accessibilityRole="header" aria-level={2} font="bold" style={styles.subtitle}>
            {txt('videoChat.intro.subtitle')}
          </CustomText>

          <CustomText>{txt('videoChat.intro.intro')}</CustomText>
          <CustomText style={{ marginTop: 12 }}>
            {txt('videoChat.intro.sprogland')}
            <CustomText onPress={() => navigation.navigate('LearnDanish')} style={{ textDecorationLine: 'underline' }}>
              {txt('videoChat.intro.sproglandLink')}
            </CustomText>
          </CustomText>

          <CustomPressable
            onPress={handleGetStartedClick}
            style={styles.btn}
            accessible
            accessibilityRole="button"
            accessibilityLabel={txt('videoChat.intro.signupBtn')}
          >
            <CustomText font={'smallBold'} style={styles.btnText}>
              {userToken ? txt('videoChat.intro.getStarted') : txt('videoChat.intro.signupBtn')}
            </CustomText>
          </CustomPressable>

          {isVolunteer && (
            <CustomPressable
              onPress={() => navigation.navigate('SnakSammenVolunteer')}
              style={styles.btn}
              accessible
              accessibilityRole="button"
              accessibilityLabel={txt('videoChat.intro.volunteerButton')}
            >
              <CustomText font={'smallBold'} style={styles.btnText}>
                {txt('videoChat.intro.volunteerButton')}
              </CustomText>
            </CustomPressable>
          )}

          {/* hide snaksammen volunteer link --> isVolunteer === false && (
            <CustomPressable
              onPress={() => URLOpener('https://boblberg.dk/snaksammen/bliv-frivillig')}
              style={styles.btn}
              accessible
              accessibilityRole="button"
              accessibilityLabel={txt('videoChat.intro.volunteerApplyButton')}
            >
              <CustomText font={'smallBold'} style={styles.btnText}>
                {txt('videoChat.intro.volunteerApplyButton')}
              </CustomText>
            </CustomPressable>
		  ) <-- hide snaksammen volunteer link */}

          <CustomText font="smallItalic">{txt('videoChat.intro.developedBy')}</CustomText>

          <View style={styles.separator} />

          <CustomText>
            {txt('videoChat.intro.activities')}
            <CustomText
              onPress={() => URLOpener('https://rødekors.dk/afdelinger')}
              style={{ textDecorationLine: 'underline' }}
            >
              {txt('videoChat.intro.activitiesLink')}
            </CustomText>
          </CustomText>
        </View>
        {!Layout.isSmallDevice && (
          <CustomPressable onPress={() => setVisible(true)} style={[styles.badge, styles.badgeBig]}>
            <CustomText font="smallBold" style={styles.badgeText}>
              {txt('videoChat.intro.badgeBig')}
            </CustomText>
          </CustomPressable>
        )}
        <InformationDialog
          visible={visible}
          close={closeRequest}
        />
      </ScrollView>
      {Layout.isSmallDevice && (
        <CustomPressable onPress={() => setVisible(true)} style={[styles.badge, styles.badgeSmall]}>
          <CustomText font="smallBold" style={styles.badgeText}>
            {txt('videoChat.intro.badgeSmall')}
          </CustomText>
        </CustomPressable>
      )}
    </MainContainer>
  )
}

const styles = StyleSheet.create({
  bannerImage: {
    alignSelf: 'center',
    height: 190,
    maxHeight: Layout.isSmallDevice ? 132 : 190,
    width: width,
  },
  btn: {
    alignSelf: 'center',
    backgroundColor: Colors.blue,
    marginBottom: 24,
    marginTop: 24,
    maxWidth: 800,
    paddingVertical: 10,
    textAlign: 'center',
    width: '100%',
    ...CornerStyles.borderRadiusL,
  },
  btnText: {
    color: Colors.white,
    textAlign: 'center',
  },
  container: {
    alignSelf: 'center',
    maxWidth: Layout.maxFeedWidth,
  },
  contentContainer: {
    marginHorizontal: 12,
    marginTop: Layout.isSmallDevice ? 0 : 50,
    paddingBottom: 80,
  },
  subtitle: { marginBottom: 12 },
  title: {
    fontSize: Layout.isSmallDevice ? 24 : 26,
    marginBottom: 8,
    marginTop: 12,
  },
  badge: {
    borderRadius: 60,
    backgroundColor: Colors.redCrossRed,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    ...dropShadow,
    position: 'absolute',
    right: 10,
    zIndex: 10,
  },
  badgeBig: {
    width: 120,
    height: 120,
    top: 170,
  },
  badgeSmall: {
    width: 70,
    height: 70,
    bottom: 10,
  },
  badgeText: {
    color: Colors.white,
    textAlign: 'center',
    lineHeight: 24,
  },
  separator: {
    borderWidth: 0.5,
    borderColor: Colors.transparent,
    borderTopColor: Colors.blackTransparent2,
    marginVertical: 26,
  },
  logo: {
    width: 200,
    height: Layout.isSmallDevice ? 60 : 70  
  }
})
